import { base, getEnv } from '../../utils';

export const getFollowers = async (userId) => {
  try {
    const { SITE_TYPE } = getEnv();
    const url = `/v1/${SITE_TYPE}/users/${userId}/followers`;

    const response = await base.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
